import type {
  CreativesConfig,
  CreativesConfigComponentKeys,
  CreativesProviderProps,
  DefaultCreativesConfig,
} from '@ad-lucy/config/creatives';
import { createContext, useContext } from 'react';

export const CreativesContext = createContext({} as CreativesConfig);

export const CreativesProvider = ({ children, config }: CreativesProviderProps): JSX.Element => (
  <CreativesContext.Provider value={config}>{children}</CreativesContext.Provider>
);

export const useCreativesConfig = (): CreativesConfig => {
  const context = useContext(CreativesContext);
  return context;
};

export const useComponentDefaults = <
  T extends CreativesConfigComponentKeys = CreativesConfigComponentKeys,
>(
  componentType: T,
): DefaultCreativesConfig['components'][T]['defaults'] => {
  const { components } = useCreativesConfig();
  return components[componentType].defaults;
};

export const useComponentSettings = <
  T extends CreativesConfigComponentKeys = CreativesConfigComponentKeys,
>(
  componentType: T,
): DefaultCreativesConfig['components'][T]['settings'] => {
  const { components } = useCreativesConfig();
  return components[componentType].settings;
};
